module.exports = "//static.hsappstatic.net/pricing-pages-lib/static-1.29381/images/hubspot-credits/hero.png"